/**
 * @generated SignedSource<<974840cffd39be762c43cbfd89d60d15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlocksRealmData$data = {
  readonly path: string;
  readonly " $fragmentType": "BlocksRealmData";
};
export type BlocksRealmData$key = {
  readonly " $data"?: BlocksRealmData$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlocksRealmData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlocksRealmData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    }
  ],
  "type": "Realm",
  "abstractKey": null
};

(node as any).hash = "f36ee0bbfca8be65a946dae121699283";

export default node;
